import { useEffect } from 'react';
import { App as AppNativa } from '@capacitor/app';
import { useAuth } from '../../context/AuthContext';
import { useTareas } from '../../context/TareasContext';
import { esApp } from '../../utils/plataforma';
import { reprogramarAvisosTareas } from '../../utils/avisosTareas';
import { sincronizarRecordatorios } from '../../utils/recordatoriosTareas';

/**
 * Mantiene al día los avisos de las tareas que te tocan (solo en la app):
 * al cambiar las tareas y al volver a la app. Tocar un aviso lleva a Tareas
 * (lo resuelve RecordatoriosGastos, que escucha todos los avisos locales).
 * También pone al día Recordatorios de iOS si está activado (ver recordatoriosTareas.ts).
 */
export const AvisosTareas: React.FC = () => {
  const { user } = useAuth();
  const { tareas, casas, cargando, conPlusTareas, marcarHecha } = useTareas();
  const sincronizar = () => sincronizarRecordatorios({ tareas, casas, uid: user?.uid, conPlus: conPlusTareas, marcarHecha })
    .catch(e => console.warn('Recordatorios de tareas', e));

  useEffect(() => {
    if (!esApp || cargando) return;
    // Un poco de margen: al marcar varias seguidas se reprograma una sola vez
    const t = setTimeout(() => {
      reprogramarAvisosTareas(tareas, casas, user?.uid).catch(e => console.warn('Avisos de tareas', e));
      sincronizar();
    }, 1500);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tareas, casas, cargando, user, conPlusTareas]);

  useEffect(() => {
    if (!esApp) return;
    const vuelta = AppNativa.addListener('appStateChange', ({ isActive }) => {
      if (!isActive || cargando) return;
      reprogramarAvisosTareas(tareas, casas, user?.uid).catch(() => {});
      // Lo tachado en Recordatorios llega aquí, al volver a la app
      sincronizar();
    });
    return () => { vuelta.then(v => v.remove()); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tareas, casas, user, cargando, conPlusTareas]);

  return null;
};
